import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchImpcEdit = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editImpc',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
      impcCode: payload.params.impcCode,
    },
  });
  return axios.put(serviceUrl, {
    centralEntryPoint: payload.params.centralEntryPoint,
  });
};

export default apiFetchImpcEdit;
